// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"Reports_maincontainer__s_LZO","mainheader":"Reports_mainheader__27dS9"};